const createPropertyHeroBannerDesktopAnchorSeparator = () => {
    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('phb-anchor-separator');
    wrapperDiv.setAttribute('role', 'presentation');

    return wrapperDiv;
};

const createPropertyHeroBannerDesktopAnchorLink = (id, title) => {
    const anchor = document.createElement('a');
    const anchorSpan = document.createElement('span');

    anchorSpan.classList.add('link-text');
    anchorSpan.innerText = title;

    anchor.classList.add('text-link', 'link-size-md', 'phb-anchor');
    anchor.href = `#${id}`;
    anchor.appendChild(anchorSpan);

    return anchor;
};

const createPropertyHeroBannerMobileAnchorOption = (id, title) => {
    const opt = document.createElement('option');

    opt.value = id;
    opt.innerText = title;

    return opt;
};

const propertyHeroBannerAnchorInit = () => {
    const allAnchorTarget = document.querySelectorAll('[data-anchor-title]');

    const desktopAnchors = [];
    const mobileAnchorOptions = [];

    allAnchorTarget.forEach(el => {
        const { id } = el;
        const title = el.dataset.anchorTitle;
        if (id && title) {
            const desktopAnchor = createPropertyHeroBannerDesktopAnchorLink(id, title);
            const desktopAnchorSeparator = createPropertyHeroBannerDesktopAnchorSeparator();
            desktopAnchors.push(desktopAnchorSeparator);
            desktopAnchors.push(desktopAnchor);

            const mobileAnchorOption = createPropertyHeroBannerMobileAnchorOption(id, title);
            mobileAnchorOptions.push(mobileAnchorOption);
        }
    });

    const anchorContainerDesktop = document.querySelectorAll('.phb-anchors-container');
    const hrLine = document.querySelectorAll('.phb-section-separator');

    if (desktopAnchors.length > 0) {
        anchorContainerDesktop.forEach(acd => {
            acd.append(...desktopAnchors);
        });
    } else {
        anchorContainerDesktop.forEach(acd => {
            acd.classList.add('no-page-anchor');
        });
        hrLine.forEach(line => {
            line.classList.add('no-page-anchor');
        });
    }

    if (mobileAnchorOptions.length > 0) {
        const anchorSelectMobile = document.querySelectorAll('#page-anchors');
        anchorSelectMobile.forEach(asm => {
            asm.append(...mobileAnchorOptions);
        });
    } else {
        const anchorContainerMobile = document.querySelectorAll('.phb-mobile-anchors-container');
        anchorContainerMobile.forEach(acm => {
            acm.classList.add('no-page-anchor');
        });
    }
};

const propertyHeroBannerMobileAnchorHandle = () => {
    const anchorSelectMobile = document.querySelectorAll('#page-anchors');

    anchorSelectMobile.forEach(asm => {
        asm.addEventListener('change', event => {
            if (event.target) {
                const elmnt = document.getElementById(event.target.value);
                if (elmnt) {
                    elmnt.scrollIntoView();
                }
            }
        });
    });
};

document.addEventListener('DOMContentLoaded', () => {
    // check if this page actually has property hero banner:
    const propertyHeroBanner = document.querySelector('.property-hero-banner-block');
    if (!propertyHeroBanner) {
        return;
    }

    propertyHeroBannerAnchorInit();
    propertyHeroBannerMobileAnchorHandle();
});
